<template>
    <div>
        <div v-for="product in products" v-if="totalPrice[product.id] || hasSingleUpgrade(product.id) || leaseProlongPrice[product.id] || hasSubscriptionPromo(product.id) || totalSubscription[product.id]">
            <div class="summary__block">
                <div class="summary__block--title">
                    <img v-bind:src="'images/' +  product.name.replace(' ', '').toLowerCase() + '_gray.png'" alt="">
                    <span>{{product.name}}</span>
                </div>
                <div v-if="totalSubscription[product.id]" class="summary__block--item">
                    <template v-if="showMaintenanceCheckbox">
                        <a href="javascript:;" class="scrollTo" @click="scrollTo(product, 'lease')">{{ getTranslation('cart-vue', 'new_leases') }}</a>
                    </template>
                    <template v-else>{{ getTranslation('cart-vue', 'new_leases') }}</template>

                    <span>{{ priceFormat(totalSubscription[product.id], false, true) }}</span>
                </div>
                <div v-if="totalPerpetual[product.id]" class="summary__block--item">
                    <template v-if="showMaintenanceCheckbox">
                        <a href="javascript:;" class="scrollTo" @click="scrollTo(product, 'perpetual')">{{ getTranslation('cart-vue', 'new_perpetual') }}</a>
                    </template>
                    <template v-else>{{ getTranslation('cart-vue', 'new_perpetual') }}</template>

                    <span>{{ priceFormat(totalPerpetual[product.id], false, true) }}</span></div>

                <div v-if="totalPerpetualUpgrade[product.id]" class="summary__block--item">
                    {{ getTranslation('cart-vue', 'perpetual_upgrade') }}
                    <span>{{ priceFormat(totalPerpetualUpgrade[product.id], false, true) }}</span>
                </div>

                <div v-if="hasSingleUpgrade(product.id)" class="summary__block--item">
                    <div
                        class="custom-control custom-checkbox b-custom-control-lg labelPrice"
                        v-if="showMaintenanceCheckbox"
                    >
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            v-model="singleUpgradeProductStatus[product.id]"
                            :value = "product.id"
                            :name = "'singleUpgrade[' + product.id + ']'"
                            @click="toggleSingleUpgrade(product.id)"
                            :id="'singleUpgradeCartToggle_' + product.id"
                        >
                        <label
                            :for="'singleUpgradeCartToggle_' + product.id"
                            class="custom-control-label d-flex flex-wrap"
                        >
                            {{ getTranslation('cart-vue', 'single_upgrade') }}
                        </label>
                        <span>{{ priceFormat(singleUpgradePrice[product.id], true, true) }}</span>
                    </div>
                    <template v-if="!showMaintenanceCheckbox">
                        {{ getTranslation('cart-vue', 'single_upgrade') }}
                        <span>{{ priceFormat(singleUpgradePrice[product.id], true, true) }}</span>
                    </template>
                </div>
                <div v-if="leaseProlongPrice[product.id] && 0" class="summary__block--item">{{ getTranslation('cart-vue', 'lease_prolongation') }} <span>{{ priceFormat(leaseProlongPrice[product.id], false, true) }}</span></div>

                <div v-if="totalSubscriptionCustomization[product.id] && 0" class="summary__block--item">
                    {{ getTranslation('cart-vue', 'subscription_customization') }}
                    <span>{{ priceFormat(totalSubscriptionCustomization[product.id], false, true) }}</span>
                </div>

                <div v-if="canPurchaseMaintenance(product.id)" class="summary__block--item">
                    <div
                        class="custom-control custom-checkbox b-custom-control-lg labelPrice"
                        v-if="showMaintenanceCheckbox"
                    >
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            v-model="$store.state.cart.maintenance[product.id].status"
                            :value = "product.id"
                            :name = "'maintenance[' + product.id + ']'"
                            @click="toggleMaintenance(product.id)"
                            :id="'maintenanceCartToggle_' + product.id"
                        >
                        <label
                            :for="'maintenanceCartToggle_' + product.id"
                            class="custom-control-label d-flex flex-wrap"
                        >
                            {{ getTranslation('cart-vue', 'maintenance') }}
                        </label>
                        <span> {{ priceFormat(totalMaintenance(product.id), true, true) }}</span>
                    </div>
                    <template v-if="!showMaintenanceCheckbox">
                        {{ getTranslation('cart-vue', 'maintenance') }}
                        <span> {{ priceFormat(totalMaintenance(product.id), true, true) }}</span>
                    </template>

                </div>

                <div v-if="volumeDiscount[product.id]" class="summary__block--item">{{ getTranslation('cart-vue', 'volume_discount') }} <span> - {{ priceFormat(volumeDiscount[product.id], false, true) }}</span></div>
                <div v-if="maintenanceDiscount[product.id]" class="summary__block--item">{{ getTranslation('cart-vue', 'maintenance_discount') }} <span> - {{ priceFormat(maintenanceDiscount[product.id], false, true) }}</span></div>
                <div v-if="hasSubscriptionPromo(product.id)" class="summary__block--item">

                    {{ getTranslation('promo2025', 'subscription_promo_cart_title') }}
                    <span> {{ priceFormat(0, true, true) }}</span>
                </div>
            </div>
        </div>
        <div class="summary__block" v-if="totalHardlocks || delivery || promoCode" >
            <div v-if="totalHardlocks" class="summary__block--item">{{ getTranslation('cart-vue', 'hardlocks') }} <span> {{ priceFormat(totalHardlocks, false, true) }}</span></div>
            <div v-if="delivery" class="summary__block--item">{{ getTranslation('cart-vue', 'delivery') }} <span> {{ priceFormat(delivery, false, true) }}</span></div>
            <div v-if="promoCode" class="summary__block--item">{{ getTranslation('cart-vue', 'promo_discount') }} <span> -{{ priceFormat(promoCode, false, true) }}</span></div>
        </div>

        <div class="summary__total">
            <div class="d-flex justify-content-between">
                <span>{{ getTranslation('cart-vue', 'total') }}</span><span>{{ priceFormat(grandTotal, true, true) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "../store";
    export default {
        computed: {
            delivery() {
                if (_.isNil(this.$store.state.cart.delivery)) {
                    return 0;
                }
                if (this.$store.state.cart.delivery == 0) {
                    return 0;
                }
                return  this.getDeliveryPrice();
            },
            singleUpgradePrice() {
                let self = this;
                let total = {};
                const keys = Object.keys(this.products);

                for (const key of keys) {
                    if (_.isUndefined(total[key])) {
                        total[key] = 0;
                    }
                    if (!_.isNil(this.$store.state.cart.singleUpgrade[key])) {
                        _.forOwn(this.$store.state.cart.singleUpgrade[key].info, function(pr, ind) {
                            if (pr.selected == true) {
                                let basePrice = self.getProgramPrice(pr.id, '', pr.licence_type, pr.product, pr.quantity);
                                total[key] = total[key] + (basePrice * pr.multiplier/100);
                            }
                        });
                    }
                }

                return total;
            },
            leaseProlongPrice() {
                let self = this;
                let total = {};
                let keys = Object.keys(this.products);

                for (const key of keys) {
                    if (_.isUndefined( total[key])) {
                        total[key] = 0;
                    }
                    if (!_.isUndefined(this.$store.state.cart.leaseProlong[key])) {
                        if (!_.isNil(this.$store.state.cart.leaseProlong[key])) {
                            if (this.$store.state.cart.leaseProlong[key].status) {
                                if (this.isTruss4Product(key)) {
                                    let info = this.$store.state.cart.leaseProlong[key].info[0];
                                    total[key] = this.getTruss4Price(info.id, '', info.licence_type, info.product, this.$store.state.cart.leaseProlong[key].info.length, true)
                                } else {
                                    _.forOwn(this.$store.state.cart.leaseProlong[key].info, function (pr, ind) {
                                        if (pr.selected) {
                                            let basePrice = self.getProgramPrice(pr.id, '', 'cloud_time_quantity', pr.product, pr.quantity, false, pr.discount, pr.days);
                                            total[key] = total[key] + basePrice;
                                        }
                                    });
                                }
                            }
                        }

                    }
                }
                return total;
            },


            maintenanceDiscount() {
                let discount = new Object;
                const keys = Object.keys(this.products);

                for (const key of keys) {
                    if (this.products[key].active_maintenance_discount >0 ) {
                        discount[key] = (Number(this.totalPerpetualPrice[key]) - Number(this.volumeDiscount[key])) *
                            Number(this.products[key].active_maintenance_discount) / 100;
                    } else {
                        discount[key] = 0;
                    }
                }
                return discount;
            },
            totalPrice() {
                let total = new Object;
                if (this.$store.state.cart.programs.length > 0) {
                    for (let i = 0; i < this.$store.state.cart.programs.length; i++) {
                        let program = this.$store.state.cart.programs[i];

                        if (_.isUndefined(total[program.product])) {
                            total[program.product] = 0;
                        }

                        total[program.product] = (Number(total[program.product]) || 0) +
                            (this.getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, program.cloud_time_quantity, false, false, program.days) || 0)
                        ;
                        if (!_.isUndefined(program.perpetual_upgrade) && program.perpetual_upgrade) {
                            total[program.product] += (this.getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, 3 *program.cloud_time_quantity) || 0)
                        }
                    }
                }

                return total;
            },
            totalPerpetualUpgrade() {
                let total = {};
                let self = this;
                _.forOwn(this.products, function(p) {
                    total[p.id] = 0;
                });
                _.forOwn(this.$store.state.cart.programs, function(program) {
                    if (program.perpetual_upgrade) {
                        total[program.product] += self.getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, program.cloud_time_quantity * 3)
                    }
                });
                return total;
            },
            totalSubscriptionCustomization() {
                let total = {};
                let self = this;
                _.forOwn(this.products, function(p) {
                    total[p.id] = 0;
                });
                _.forOwn(this.$store.state.cart.leaseProlongConfigs, function(l) {
                    total[l.product] += self.getProgramPrice(l.program_id, '', 'cloud_time_quantity', l.product, l.quantity, false, l.discount, l.daysDiff);
                });
                return total;
            },
            totalPerpetual() {
                return {};
            },
            totalSubscription() {
                let self = this;
                let total = {};
                _.forOwn(this.products, function(p) {
                    total[p.id] = (Number(self.totalLease[p.id]) || 0) +
                        (Number(self.totalSubscriptionCustomization[p.id]) || 0) +
                        (Number(self.leaseProlongPrice[p.id]) || 0);
                });
                return total;
            },
            totalLease() {
                let total = new Object;
                if (this.$store.state.cart.programs.length > 0) {
                    for (let i = 0; i < this.$store.state.cart.programs.length; i++) {
                        let program = this.$store.state.cart.programs[i];

                        if (_.isUndefined(total[program.product])) {
                            total[program.product] = 0;
                        }

                        total[program.product] = (Number(total[program.product]) || 0) +
                            (this.getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, program.cloud_time_quantity, false, 0, program.days) || 0);

                        // if (!_.isUndefined(program.perpetual_upgrade) && program.perpetual_upgrade) {
                        //     total[program.product] += (this.getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, 3 *program.cloud_time_quantity) || 0)
                        // }
                    }
                }

                return total;
            },
            totalPerpetualPrice() {
                return {};
            },
            volumeDiscount() {
                let countLicences = new Object;
                let priceLicences = new Object;
                let volumeDiscount = new Object;

                for (let product in  this.products) {
                    countLicences[product] = 0;
                    priceLicences[product] = 0;
                    volumeDiscount[product] = 0;
                }
                if (this.$store.state.cart.programs.length > 0) {
                    for (let i = 0; i < this.$store.state.cart.programs.length; i++) {
                        let program = this.$store.state.cart.programs[i];
                        countLicences[program.product] += Number(program.local_quantity) +
                            Number(program.network_quantity);
                        priceLicences[program.product] +=
                            (this.getProgramPrice(program.id, '', 'local_quantity', program.product, program.local_quantity) || 0) +
                            (this.getProgramPrice(program.id, '', 'network_quantity', program.product, program.network_quantity) || 0);
                    }
                }

                for (let product in countLicences) {

                    for (let key in this.volumeDiscountValues[product]) {
                        if (
                            countLicences[product] <= this.volumeDiscountValues[product][key].max &&
                            countLicences[product] >= this.volumeDiscountValues[product][key].min
                        ) {
                            volumeDiscount[product] = priceLicences[product] * this.volumeDiscountValues[product][key].discount / 100;
                        }
                    }
                }

                return volumeDiscount;
            },
            totalHardlocks() {
                let total = 0;
                let currency = window.shopConfigOptions.currency;
                if (this.$store.state.cart.hardlocks.length > 0) {
                    for (let i = 0; i < this.$store.state.cart.hardlocks.length; i++) {
                        let hardlock = this.$store.state.cart.hardlocks[i];
                        if (!_.isUndefined(hardlock.price_list) ) {
                            if (!_.isUndefined(hardlock.price_list[currency]) && hardlock.isNew) {
                                total += Number(hardlock.price_list[currency]);
                            }
                        }
                    }
                }
                return total;
            },
            totalCart() {
                let total = 0;
                total += Number(this.totalHardlocks) || 0;
                total += Number(this.delivery) || 0;
                for (let item in this.products) {
                    total += Number(this.totalPrice[item]) || 0;
                    total += Number(this.totalMaintenance(item)) || 0;
                    total += Number(this.singleUpgradePrice[item]) || 0;
                    total += Number(this.leaseProlongPrice[item]) || 0;
                    total += Number(this.totalSubscriptionCustomization[item]) || 0;

                    total -= Number(this.volumeDiscount[item]) || 0;
                    total -= Number(this.maintenanceDiscount[item]) || 0;
                }
                return total;
            },
            grandTotal() {
                return this.totalCart - this.promoCode;
            },
            promoCode() {
                if (this.loggedInUser) {
                    return 0;
                }
                if (_.isNil(this.promoInfo)) {
                    return 0;
                }
                if (this.hasPromoCode) {
                    return (this.totalCart - this.totalHardlocks) * Number(this.promoInfo.discount) / 100;
                }
                return 0;
            },
            programsLength() {
                return _.size(this.$store.state.cart.programs);
            }
        },
        methods: {
            hasSubscriptionPromo(id) {
                if (_.isNil(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                if (_.isEmpty(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                if (this.$store.state.cart.subscriptionPromo.product != id) {
                    return false;
                }
                return true;
            },
            scrollTo(product, element = '') {
                //new licenses
                let id = 'undefined';
                let top = 10;
                if (element == 'lease' || element == 'perpetual') {
                    id = 'v-pills-'+product.name.replace(/\s+/g, '-').toLowerCase()+'-lease-tab';
                    $('#v-pills-'+product.name.replace(/\s+/g, '-').toLowerCase()+'-'+element+'-tab').click();
                }
                if (element == 'singleUpgrade') {
                    top = -20;
                    id = 'singleUpgradeBox_' + product.id;
                    $('#v-pills-'+product.name.replace(/\s+/g, '-').toLowerCase()+'-perpetual-tab').click();
                }
                if ($("#" + id).length) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#" + id).offset().top + top
                    }, 400);
                }
            },
            canPurchaseMaintenance(id) {
                if (this.showMaintenanceCheckbox) {
                    return this.getProductMaintenancePrice(id);
                }
                return this.totalMaintenance(id);
            },
            removeFromCart(item) {
                this.$store.commit('removeFromCart', item);
            },
            toggleMaintenance(id) {
                this.$store.commit('toggleMaintenance', {product: id, price: this.totalMaintenance[id]});
                this.resetCartStep();
            },

            resetCartStep() {
                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
                this.$store.commit('emptyHardlocks');
                this.$store.commit('setMustConfirm', 1);
                this.$store.commit('addPromoLease', {});
            },
            totalMaintenance(id) {
                let total = 0;
                if (!_.isNil(this.$store.state.cart.maintenance[id])) {
                    if (this.$store.state.cart.maintenance[id].status == true) {
                        total = this.getProductMaintenancePrice(id);
                    }
                }

                return total;
            },
            hasSingleUpgrade(id) {
                if (this.showMaintenanceCheckbox && !_.isNil(this.$store.state.cart.singleUpgrade[id])) {
                    return true;
                } else if (this.anySingleUpgradeProgramsEnabled(id)) {
                    return true;
                }
                return false;
            },
            anySingleUpgradeProgramsEnabled(id) {
                let hasEnabled = false;
                if (_.isNil(this.$store.state.cart.singleUpgrade[id])) {
                    return hasEnabled;
                }
                if (_.isNil(this.$store.state.cart.singleUpgrade[id].info)) {
                    return hasEnabled;
                }
                _.forOwn(this.$store.state.cart.singleUpgrade[id].info, function(pr, ind) {
                    if (pr.selected == true) {
                        hasEnabled = true;
                    }
                });

                return hasEnabled;
            },
            toggleSingleUpgrade(id) {
                this.scrollTo(this.products[id], 'singleUpgrade');
                this.$root.$emit("toggleProduct", id)
            }
        },
        mounted() {
            let self = this;

            Object.entries(this.products).forEach(([key, pr]) => {
                if (!_.isUndefined(this.maintenancePrice[key]) ) {
                    self.cartMaintenance[key].price = self.maintenancePrice[key]
                }
                if (!_.isUndefined(this.singleUpgradePriceInit[key])) {
                    self.$store.commit('toggleSingleUpgradePrice', {
                        product: key,
                        price: self.singleUpgradePriceInit[key]
                    });

                }
            });
            Object.entries(this.products).forEach(([key, pr]) => {
                if (self.singleUpgradePrice[pr.id]) {
                    self.singleUpgradeProductStatus[pr.id] = true;
                } else {
                    self.singleUpgradeProductStatus[pr.id] = false;
                }
            });
            this.$root.$on("toggleProductCart",  (item, response) => {
                this.singleUpgradeProductStatus[item.product] = item.status;
            });
        },
        data() {
            return {
                products: window.jsonProducts,
                volumeDiscountValues:  window.jsonVolumeDiscount,
                expressDeliveryPrice:  window.expressDeliveryPrice,
                loggedInUser: window.loggedInUser,
                justLoggedIn: window.justLoggedIn,
                justLoggedOut: window.justLoggedOut,
                maintenancePrice: window.maintenancePrice,
                singleUpgradePriceInit : window.singleUpgradePrice,
                leaseProlongPriceInit  : window.leaseProlongPrice ,
                cartMaintenance: store.state.cart.maintenance,
                singleUpgradeProductStatus: {},
                showMaintenanceCheckbox: !_.isNil(window.showMaintenanceCheckbox),
                navigation: window.quickNavigationUrls,
                hasPromoCode: window.promoCode,
                promoInfo: window.promoInfo
            };
        }

    }
</script>

<style>


.labelPrice {
    display: flex; justify-content: space-between; width: 100%;
    padding-left: 0px;
}
.labelPrice .custom-control-label {
    font-weight: 400;
    color: #333333
}
.scrollTo {
    color: #333333;
}

</style>
